import { render } from "./CustomTable.vue?vue&type=template&id=f61b7200&scoped=true"
import script from "./CustomTable.vue?vue&type=script&lang=js"
export * from "./CustomTable.vue?vue&type=script&lang=js"

import "./CustomTable.vue?vue&type=style&index=0&id=f61b7200&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f61b7200"]])

export default __exports__